import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_GENERIC_LOG = 'genericLogFilters'

const GenericLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_GENERIC_LOG)

  const moduleOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'module', []),
    [filterMeta],
  )
  const serviceOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'service', []),
    [filterMeta],
  )
  const actionOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'action', []),
    [filterMeta],
  )
  const statusOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'status', [
        'PENDING',
        'IN_PROGRESS',
        'SUCCESS',
        'PARTIAL_SUCCESS',
        'FAILED',
      ]),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="module"
          label="Module"
          options={moduleOptions}
          defaultValue={filters.module || ''}
          setValue={(_field: string, value: string) =>
            setField('module', value)
          }
        />
      </div>

      <div className="min-w-[220px]">
        <Dropdown
          name="service"
          label="Service"
          options={serviceOptions}
          defaultValue={filters.service || ''}
          setValue={(_field: string, value: string) =>
            setField('service', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="action"
          label="Action"
          options={actionOptions}
          defaultValue={filters.action || ''}
          setValue={(_field: string, value: string) =>
            setField('action', value)
          }
        />
      </div>

      <div className="min-w-[180px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <FilterTextInput
        label="Requested By"
        value={filters.requestedBy || ''}
        onApply={(value) => setField('requestedBy', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default GenericLogFilterForm
